import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { IconButton, Stack } from "@mui/material";
import { useVisualContext } from "../../../../../../context/VisualContext";

interface Props {
  onClick?: () => void;
  ProductName?: React.ReactElement;
  readonlyMode?: boolean;
}

export default function BackToButton({ onClick, ProductName, readonlyMode }: Props) {
  const { showSideMenu } = useVisualContext();
  return (
    <Stack direction="row" sx={{ alignItems: "center", gap: 1, pl: showSideMenu ? 0 : 1.4 }}>
      <IconButton onClick={onClick} disabled={readonlyMode}>
        <ArrowBackRoundedIcon />
      </IconButton>
      {!showSideMenu && ProductName}
    </Stack>
  );
}
